import React, {Component} from 'react';

class Confirmation extends Component
{
	render()
	{
		return(
			<div className="container">
				<h3>Your request has been received. Thank you!</h3>
				<a className="unavailable-button" href="#/">Return to Search</a>
			</div>
		)
	}
}

export default Confirmation;


// WEBPACK FOOTER //
// ./src/components/Confirmation.js